export default "__VITE_ASSET__22fc7ab9__"